import DOMPurify from 'dompurify';

/**
 * 渲染 v-html 前的第二道防線（後端已消毒，此處防舊資料或繞過）。
 */
export function sanitizeHtml(html) {
    if (html == null || html === '') {
        return '';
    }
    return DOMPurify.sanitize(String(html), {
        USE_PROFILES: { html: true }
    });
}
